// extracted by mini-css-extract-plugin
export default {"isPreRelease":"ServicePackVersionDetail_isPreRelease__rXIUI","preReleaseVersion":"ServicePackVersionDetail_preReleaseVersion__H0B09"};